import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".RadioCardGroup-module_radioGroupHorizontal__6U5Dx {\n  display: flex;\n  flex-direction: row;\n}";
var styles = {"radioGroupHorizontal":"RadioCardGroup-module_radioGroupHorizontal__6U5Dx"};
styleInject(css_248z);

export { styles as default };
